import React from 'react';
import { capitalizeString, dynamicUrlNavigation } from '.';

interface ErrorMessage {
    basicPath: string;
    name?: string;
    customMessage?: string;
    externalURL?: string;
}


const ErrorMessage = ({ basicPath, name, customMessage, externalURL }: ErrorMessage) => {
    const renderURLUI = () => {
        if(!!externalURL) {
            return <p>{`${customMessage}`} <span onClick={() => window.open(externalURL, '_blank')} className='cursor-pointer font-semibold underline underline-offset-1'>Click here to create {(name || basicPath)?.toLowerCase()}.</span></p>
        }
        return (!!customMessage ?
            <p>{`${customMessage}`} <span onClick={() => dynamicUrlNavigation(basicPath)} className='cursor-pointer font-semibold underline underline-offset-1'>Click here to create {(name || basicPath)?.toLowerCase()}.</span></p> :
            <p>{`${capitalizeString(name || basicPath)} Not Found!`} <span onClick={() => dynamicUrlNavigation(basicPath)} className='cursor-pointer font-semibold underline underline-offset-1'>Click here to create {(name || basicPath)?.toLowerCase()}.</span></p>);
    }
    return renderURLUI();
}

export default ErrorMessage;